import { User, QueryResult, QueryFilters } from '../types';
import api from '../api';
import isGranted from '../auth/isGranted';

export default {
  find(id: string): Promise<User> {
    return api
      .get(`users/${id}`)
      .then(response => response.data);
  },
  findAll(accountId: string, filters: QueryFilters): Promise<QueryResult> {
    if (!isGranted('FIND_USERS')) return Promise.reject();
    return api
      .get(`accounts/${accountId}/users`, { params: filters })
      .then(response => response.data);
  },
};
